import { AssetsPage } from './AssetsPage';

export function TrainingPage() {
  return (
    <AssetsPage
      page="training"
      title="Training"
      description="Access training videos, guides, and educational resources"
    />
  );
}
